// JavaScript files are compiled and minified during the build process to the assets/built folder. See available scripts in the package.json file.

import menuOpen from './menuOpen';
// import infiniteScroll from './infiniteScroll';
// import lightbox from './lightbox';
import Masonry from '../../node_modules/masonry-layout/masonry';
import imagesLoaded from '../../node_modules/imagesloaded/imagesLoaded';

import '../css/index.css';

const postFeed = () => {
  const grid = document.querySelector('.grid');

  if (!grid) return;

  let msnry;

  imagesLoaded(grid, () => {
    msnry = new Masonry(grid, {
      itemSelector: '.grid-item',
      columnWidth: '.grid-sizer',
      gutter: '.gutter-sizer',
      percentPosition: true,
      stamp: '.related-title',
      hiddenStyle: { transform: 'translateY(50px)', opacity: 0 },
      visibleStyle: { transform: 'translateY(0)', opacity: 1 },
      horizontalOrder: true
    });

    msnry.on('layoutComplete', () => {
      grid.classList.add('initialized');
    });

    msnry.layout();

    const callback = (items, loadNextPage) => {
      imagesLoaded(items, (loaded) => {
        msnry.appended(items);
        msnry.layout();

        loaded.elements.forEach((item) => {
          item.style.visibility = 'visible';
        });
        loadNextPage();
      });
    }

    // pagination(true, callback, true);
  });
}

/*const shit = [
  {
    post_class: '',
    title: '',
    url: '',
    img_url: '',
    primary_tag: {
      url: '',
      name: ''
    },
    date: ''
  }
];*/

menuOpen();
// infiniteScroll();
postFeed();
// new lightbox('.kg-image-card > .kg-image[width][height], .kg-gallery-image > img');
